export enum ProcessName {
    PROVISIONING = 'PROVISIONING',
    SALES = 'SALES',
}

export enum Phase {
    SALES = '100000000',
    PROVISIONING = '100000001',
}
